import request from '../../api';

export const createClient = (clientData, city) => {
    let formData = new FormData();
    Object.entries(clientData).forEach(([key, value]) => {
        if (value) formData.append(key, value);
    });
    formData.append("city", city);

    return request("panpartner:client.edit.form", "editClient", formData).then(
        success => {
            return Promise.resolve(success);
        },
        err => {
            return Promise.reject(err);
        }
    );
};

export const refreshClientsList = (
    setIsLoading,
    component,
    getSettingsAction,
    formId,
    city,
    isOneResult,
    requestOptions,
    setFormSettings,
    setResponse
) => {
    setIsLoading(true);
    return request(component, getSettingsAction, { formId, city, isOneResult, ...requestOptions }).then(
        (resp) => {
            setFormSettings(resp?.questions || []);
            setResponse(resp);
            setIsLoading(false);
            return Promise.resolve(resp);
        },
        err => {
            setIsLoading(false);
            return Promise.reject(err);
        }
    );
};
